import { UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { YourListService } from './../../../pages/your-list/your-list.service';
import { AuthService } from './../../../services/auth/auth.service';
import { Component, Input, OnInit, OnDestroy, ChangeDetectionStrategy } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SharedService } from '../../../services/shared/shared.service';
import { EmailService } from '../email/email.service';
import { takeUntil } from 'rxjs/operators';
import { RoutingService } from '../../../services/routing/routing.service';
import { Subject } from 'rxjs';
import { LayoutService } from '../../../services/layout.service';
import { SidenavContent } from '../sidenav-content';

@Component({
  selector: 'add-list',
  templateUrl: './add-list.component.html',
  styleUrls: ['./add-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class AddListComponent extends SidenavContent implements OnInit, OnDestroy {
  @Input() item: any;
  @Input() agcontrolid: string;
  @Input() source: string;
  @Input() listId: number;

  inputCreate: string;
  lists: any = [];
  listInfo: any;
  showEmailForm = false;
  emailForm: UntypedFormGroup;

  private _chosenList: number;
  private _unsubscribe: Subject<void> = new Subject<void>();

  constructor(
    public authService: AuthService,
    private _emailService: EmailService,
    private _fb: UntypedFormBuilder,
    private _routingService: RoutingService,
    private _snackBar: MatSnackBar,
    private _sharedService: SharedService,
    private _yourListService: YourListService,
    private _layoutService: LayoutService,
  ) {
    super(_layoutService);

    this.emailForm = this._fb.group({
      // FromAddressName: '',
      FromAddress: '',
      ToAddress: [
        '',
        [Validators.required, Validators.pattern('[a-z0-9._%+-]+@[a-z0-9.-]+.[a-z]{2,3}$')],
      ],
      Subject: ['', Validators.required],
      MessageBody: ['', Validators.required],
      IsBodyHtml: true,
    });
  }

  ngOnDestroy(): void {
    this._unsubscribe.next();
    this._unsubscribe.complete();
  }

  ngOnInit() {
    if (this.authService.isGuest()) {
      this.getListInfo();
    } else {
      this._yourListService.lists$.pipe(takeUntil(this._unsubscribe)).subscribe((response) => {
        this.lists = response;
      });
    }

    this._sharedService
      .getLoadGuestListBS()
      .pipe(takeUntil(this._unsubscribe))
      .subscribe((flag) => {
        if (flag && this.authService.isGuest()) {
          this.showEmailForm = false;
          this.getListInfo();
        }
      });
  }

  validSendEmail() {
    const formValue = this.emailForm.getRawValue();
    const postBody = {
      FromAddress: formValue.FromAddress,
      FromAddressName: '',
      ToAddress: formValue.ToAddress,
      CCAddress: '',
      BCCAddress: '',
      Subject: formValue.Subject,
      MessageBody: formValue.MessageBody,
      IsBodyHtml: true,
    };
    this._emailService.SendEmail(postBody).subscribe((response) => {
      if (response.status == '200 OK') {
        this.openSnackBar(response.message, 'ok');
        this.goBack();
      }
    });
  }

  // ----------------- guest list functionality starts ---------------------

  emailList() {
    this.showEmailForm = true;
  }

  printList() {
    const listItemIdArrayMUL = [];
    const array = this.listInfo.listItems;
    for (let index = 0; index < array.length; index++) {
      const element = array[index];
      listItemIdArrayMUL.push(element.listItemId);
    }

    this._yourListService.printList(this.listId, listItemIdArrayMUL).subscribe((response) => {
      const printBody = response.data.body;
      const popupWin = window.open('', '_blank', 'top=0,left=0,height=100%,width=auto');
      popupWin.document.open();
      popupWin.document.write(printBody);
      popupWin.document.close();
      popupWin.print();
      popupWin.close();
    });
  }
  saveList() {
    this.closeNav();
    this._routingService.goToLogin();
  }

  deleteItem4frmList(item) {
    const listItemsArray = [];
    listItemsArray.push(item.listItemId);
    this._yourListService.deleteListItem(0, listItemsArray).subscribe(
      () => {
        this.getListInfo();
      },
      (error: unknown) => {
        this._sharedService.openSnackBar('Unable to delete list item.');
        console.error(error);
      },
    );
  }

  getListInfo(id: number = 0): void {
    this._yourListService.getListInfo(id).subscribe((data) => {
      this.listInfo = data;
      if (this.listInfo.listItems.length) {
        const from = this.listInfo.emailFromAddress;
        let body = '';
        const items = this.listInfo.listItems;
        for (let index = 0; index < items.length; index++) {
          const element = items[index];
          let string = 'Title:' + element.title + ' By:' + element.author + ', \r\n';
          string += '\r\n';
          const dummyString = body.concat(string);
          body = dummyString;
        }
        // fill the form
        this.emailForm.patchValue({
          FromAddress: from,
          Subject: 'Session List',
          MessageBody: body,
        });
        this.emailForm.controls['FromAddress'].disable();
        this.emailForm.controls['MessageBody'].disable();
      }
    });
  }

  // --------------- guest list functionality ends -------------------
  moveToList(listId): void {
    if (!this.item.source && !this.item.libraryDbPoolKey) {
      this.openSnackBar('unable to add item to the list', 'ok');
      return;
    }

    let result: any;
    if (this.item.source) {
      this._yourListService
        .addItemToListFromSource(this.item.agcontrolid, this.item.source, listId)
        .subscribe(() => this.closeNav());
    } else {
      this._yourListService
        .addItemToListFromLibKey(this.item.agControlId, this.item.libraryDbPoolKey, listId)
        .subscribe((response) => {
          if (response.status === '200 OK') {
            this.openSnackBar(response.data, 'ok');
          }
        });
    }
  }

  createList() {
    if (SharedService.isEmpty(this.inputCreate)) {
      this._sharedService.openSnackBar('Enter name for this list', 'ok');
      return;
    }

    if (this.inputCreate.trim().length > 50) {
      this.openSnackBar('List title cannot exceed 50 characters', 'ok');
      return;
    }

    this._yourListService.createList(this.inputCreate).subscribe(
      (listId) => {
        this._chosenList = listId;
        this.moveToList(this._chosenList);
        this.inputCreate = '';
        this._yourListService.loadLists().subscribe(
          () => {},
          (error: unknown) => {
            this._sharedService.openSnackBar('Unable to load lists.');
            console.error(error);
          },
        );
      },
      (error: unknown) => {
        this._sharedService.openSnackBar('Unable to create list');
        console.error(error);
      },
    );
  }

  goBack() {
    this.showEmailForm = false;
  }
  //      ---------------------------------------------------------------------------
  //      -------------------------USER EXPERIENCE-----------------------------------
  //      ---------------------------------------------------------------------------

  // snackbar alert
  openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action, {
      duration: 5000,
      verticalPosition: 'top',
    });
  }
}
